import React, { useState, useEffect } from 'react';
import Head from 'next/head';
import { isEmpty } from 'lodash';
import { useRouter } from 'next/router';

import { getLayoutProps } from '@/utils/layout/layout';
import User from '@/store/user';
import AddressesSection from '@/components/AddressesSection/AddressesSection';
import { getOrFetchConfiguration } from '@/utils/getConfiguration';
import PageLayout from '@/components/PageLayout';
export default function UserAddresses({ responsiveLogo, image }) {
  const [user, setUser] = useState();
  const [config, setConfig] = useState();

  const router = useRouter();
  useEffect(() => {
    const user$ = User.subscribe(_user => {
      if (isEmpty(_user)) {
        router.replace('/');
        return;
      }
      setUser(_user);
    });
    return () => user$.unsubscribe();
  }, []);

  useEffect(() => {
    async function getConfiguration() {
      const configuration = await getOrFetchConfiguration();
      setConfig(configuration);
    }
    getConfiguration();
  }, []);

  if (!user?._id) return null;

  return (
    <>
      <Head>
        <title>{process.env.displayName}</title>
        <meta name="description" content={`App for ${process.env.displayName} by Wave Grocery`} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href={responsiveLogo} />
      </Head>
      <AddressesSection user={user} image={image} config={config} />
    </>
  );
}

UserAddresses.getLayout = function getLayout(page) {
  return (
    <PageLayout isUserLayout userSelectedMenu={'addresses'}>
      {page}
    </PageLayout>
  );
};

export async function getStaticProps({ locale }) {
  const layoutProps = await getLayoutProps({ headerProps: { selectedIndex: 0 } }, locale);
  const image = layoutProps?.emptyStates?.address_empty_state?.url
    ? layoutProps?.emptyStates?.address_empty_state?.url
    : null;
  const messages = {
    common: (await import(`../../../../prebuild-data/i18n/${locale}/common.json`)).default,
    user_address: (await import(`../../../../prebuild-data/i18n/${locale}/user_address.json`)).default,
  };

  return {
    props: {
      ...layoutProps,
      messages,
      image,
    },
  };
}
